<script>
import Loader from "@/components/Loader";

export default {
  components: {
    Loader,
  },
  props: {
    title: {
      type: String,
      default: "Veuillez patienter...",
    },
  },
};
</script>

<template>
  <div class="flex-column items-center justify-center">
    <span class="m-2 text-2xl text-white">{{ title }}</span>
    <div class="flex justify-center items-center p-5">
      <Loader />
    </div>
  </div>
</template>
